import { Component, OnInit, inject, signal, ElementRef, viewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router, RouterLink } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { authenticate, isAuth } from './auth'; // Adjust path if needed
import { Navbar } from './navbar'; // Adjust path if needed
import { environment } from '../../environments/environment';

// Declare the global google object provided by the GIS script
declare var google: any;

@Component({
  selector: 'app-login',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, RouterLink, Navbar],
  template: `
      <div>
        <app-navbar />
        <div class="py-5"></div>

      <div class="justify-content-center align-items-center" style="height: 71.9vh; display: flex;">
        <div class="container col-lg-5 p-2 text-center rounded-left">
          
          <div class="text-center text-info mb-3">
            Inicie con su cuenta de google para maximizar la seguridad
          </div>

          <!-- Contenedor del Botón de Google -->
          <div class="my-3 d-flex justify-content-center">
            <div #googleBtnRef></div>
          </div>

          <form [formGroup]="loginForm" (ngSubmit)="handleSubmit()" class="col-lg-12">
            <input
              class="form-control my-2"
              type="email"
              placeholder="Email"
              formControlName="email"
            />
            <input
              class="form-control my-2"
              type="password"
              placeholder="Password"
              formControlName="password"
            />
            
            <div class="my-1">
              <button type="submit" class="btn btn-info w-100" [disabled]="loading()">
                {{ textChange() }}
              </button>
            </div>
            
            <a routerLink="/users/password/forget" class="btn btn-light btn-sm mt-2">
              Olvidaste tu contraseña?
            </a>
          </form>
          
        </div>
      </div>
    </div>
  `
})
export class LoginComponent implements OnInit {
  private fb = inject(FormBuilder);
  private router = inject(Router);
  private http = inject(HttpClient);

  // Reference to the div where the Google Button will be rendered
  readonly googleBtnRef = viewChild<ElementRef>('googleBtnRef');

  // Signals for local state control
  readonly loading = signal(false);
  readonly textChange = signal('Iniciar sesión');

  ipData: any = null;

  loginForm: FormGroup = this.fb.group({
    email: ['', [Validators.required, Validators.email]],
    password: ['', [Validators.required]]
  });

  ngOnInit(): void {
    // Fetch IP location equivalent to React useEffect
    // this.http.get('https://ipapi.co/json/').subscribe({
    //   next: (data) => {
    //     this.ipData = data;
    //   },
    //   error: (err) => console.error('Error fetching IP location:', err)
    // });

    // Initialize Google Auth
    this.initGoogleAuth();
  }

  initGoogleAuth(): void {
    // Wait briefly to ensure the View Child and Google script are ready
    setTimeout(() => {
      if (typeof google !== 'undefined') {
        google.accounts.id.initialize({
          client_id: environment.googleClientId, // Ensure this exists in your environment files
          callback: (response: any) => this.handleGoogleResponse(response.credential)
        });

        const container = this.googleBtnRef()?.nativeElement;
        if (container) {
          google.accounts.id.renderButton(container, {
            theme: 'outline',
            size: 'large',
            width: '320' // Matches your React styling
          });
        }
      } else {
        console.warn('Google scripts not loaded');
      }
    }, 500);
  }

  handleGoogleResponse(idToken: string): void {
    const apiUrl = environment.apiURL;
    this.http.post(`${apiUrl}/api/auth/googlelogin`, {
      idToken,
      ip: this.ipData
    }).subscribe({
      next: (res: any) => {
        this.informParent(res);
      },
      error: (error) => {
        console.error('GOOGLE SIGNIN ERROR', error);
      }
    });
  }

  informParent(response: any): void {
    authenticate(response, () => {
      const auth = isAuth();
      if (auth && auth.rol === 3) {
        this.router.navigate(['/carpeta']);
      } else {
        this.router.navigate(['/carpeta']);
      }
    });
  }

  handleSubmit(): void {
    if (this.loginForm.valid) {
      this.loading.set(true);
      this.textChange.set('Submitting');

      const { email, password } = this.loginForm.value;
      const apiUrl = environment.apiURL;

      this.http.post(`${apiUrl}/api/auth/login`, {
        email,
        password,
        ip: this.ipData
      }).subscribe({
        next: (res: any) => {
          this.loading.set(false);
          authenticate(res, () => {
            const auth = isAuth();
            if (auth && auth.rol === 1) {
              this.router.navigate(['/']);
            } else {
              this.router.navigate(['/carpeta']);
            }
          });
        },
        error: (err) => {
          this.loading.set(false);
          this.textChange.set('Iniciar sesión');
          console.error(err);
          alert(err.error?.errors || 'Error en el servidor');
        }
      });
    } else {
      alert('Rellene todos los campos correctamente');
    }
  }
}